import React from 'react';
import PropTypes from 'prop-types';
import Validator from 'mixins/validator';
import Resetter from 'mixins/resetter';
import { Button, IconButton } from 'react-toolbox/lib/button';
import { Dialog } from 'react-toolbox';
import StyledSelect from 'components/StyledSelect';
import TextArea from 'components/TextArea';
import MessageBox from 'components/MessageBox';
import { RESCHEDULE_REASONS, ASSESSMENT_RESCHEDULE_REASONS } from 'config/constants';
import S from 'modal.scss';

const DEFAULT_STATE = {
  reason: '',
  note: '',
  errors: {},
};

class RescheduleAppointmentModal extends Resetter(Validator(React.Component)) {
  static VALIDATIONS = { note: true, reason: true }

  get valuesForValidation() {
    return { note: this.state.note, reason: this.state.reason };
  }

  static DEFAULT_STATE = { reason: '', note: '', errors: {} };

  state = DEFAULT_STATE;

  componentWillReceiveProps = nextProps => this.setState({ errors: nextProps.errors })

  handleReasonChange = e => this.setState({ reason: e });

  handleNoteChange = e => this.setState({ note: e.target.value });

  handleSubmit = () => {
    if (!this.validate()) return;
    const { reason, note } = this.state;
    const { ssBlockage, onSubmit } = this.props;
    const event = {
      kind: 'reschedule',
      rescheduled: { reason },
      note: ssBlockage ? `${note}
${ssBlockage}` : note,
    };
    onSubmit(event);
  }

  render = () => {
    const { type, active } = this.props;
    const { reason, note, errors } = this.state;
    return (<Dialog
      active={active}
      className={S.modal}
      type="fullscreen"
      onEscKeyDown={this.handleClose}
      onOverlayClick={this.handleClose}
    >
      <IconButton
        icon="close"
        className={S.close}
        onClick={this.handleClose}
      />
      <h5 className={S.title}>Reschedule Appointment</h5>
      <StyledSelect
        className={S.select}
        label="Reason *"
        onChange={this.handleReasonChange}
        options={type === 'Assessment' ?
          ASSESSMENT_RESCHEDULE_REASONS : RESCHEDULE_REASONS}
        value={reason}
        placeholder={'Select reason'}
        error={errors.reason}
      />
      <TextArea
        label="Note *"
        value={note}
        onChange={this.handleNoteChange}
        errors={errors.note}
      />
      {errors.assignee && <MessageBox error message={errors.assignee} />}
      <Button
        label="Reschedule"
        flat inverse ripple
        className={S.submit}
        onClick={this.handleSubmit}
      />
    </Dialog>);
  }
}

RescheduleAppointmentModal.propTypes = {
  type: PropTypes.string.isRequired,
  active: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func,
  onClose: PropTypes.func,
  ssBlockage: PropTypes.string,
};

RescheduleAppointmentModal.defaultProps = {
  active: false,
  onClose: () => { },
  onSubmit: () => { },
};

export default RescheduleAppointmentModal;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseAppointments/components/rescheduleAppointmentModal.jsx